import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InteractivePropertyMap from '../components/InteractivePropertyMap';
import InvestmentNotFound from '../components/InvestmentNotFound';
import { useSearch } from '../contexts/SearchContext';
import { sendPropertySelected } from '../utils/iframeMessenger';

/**
 * Navigator-only view (route /navigator).
 *
 * Renders the interactive map alone — no filters, counter, cards or footer.
 * Embeddable in a host page (iframe); each property click is propagated to the
 * parent window via sendPropertySelected (TWOPOINT_/TWIPOINT_PROPERTY_SELECTED).
 *
 * Version (V2/V3) is resolved per investment inside InteractivePropertyMap
 * from navigator_config_v2.version — nothing version-specific lives here.
 */
function NavigatorOnly() {
  const { allPropertiesForMap, filteredProperties, loading, error, investmentData, globalConfig } = useSearch();
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);
  const navigate = useNavigate();

  const handlePropertySelection = (propertyId) => {
    sendPropertySelected(propertyId);

    if (investmentData?.navigatorClickOpensCard) {
      navigate(`/properties/${encodeURIComponent(propertyId)}`);
      return;
    }

    setSelectedPropertyId((prev) => (prev === propertyId ? null : propertyId));
  };

  if (loading) {
    return <div className="loading">Ładowanie...</div>;
  }

  if (error && error.includes('Nie znaleziono inwestycji')) {
    return <InvestmentNotFound email={globalConfig?.fallback_email} />;
  }

  if (error) {
    return <div className="error">Błąd: {error}</div>;
  }

  return (
    <div className="navigator-only">
      <InteractivePropertyMap
        properties={allPropertiesForMap}
        filteredProperties={filteredProperties}
        investmentData={investmentData}
        selectedPropertyId={selectedPropertyId}
        onPropertySelect={handlePropertySelection}
        hideToolbar
      />
    </div>
  );
}

export default NavigatorOnly;
